export default __webpack_public_path__ + "static/media/Coinbase2.de68a122.png";